<template>
    <div class="sms-page card-info">
        <div class="text-left px-2 mt-2">
            <h5>{{$t('configured-number')}}</h5>
            <p class="mb-4">{{$t('test-sms-config')}}</p>
        </div>
        <base-table
            class="mb-4"
            :columns="columns"
            :items="numbers"
            :loading="loading"
        >
            <template #cell(description)="{ item }">
                <template v-if="item.attributes.config">
                    {{$t('authorized-person')}}: {{ item.attributes.config.name }} <br/> {{ item.attributes.config.carrier_account_name }} - {{ item.attributes.config.carrier_account_number }}
                </template>
            </template>
            <template #cell(actions)="{ item }">
                <button type="button" class="btn btn-danger rounded-pill style-btn" @click="deactivateNumberAlert(item.id)">
                    {{$t('deactivate')}}
                </button>
            </template>
        </base-table>
    </div>
</template>
<script>

// Internal mixins
import DeactivateNumberMixin from '@/core/mixins/DeactivateNumberMixin';

// Internal components
import BaseTable from '@/core/components/BaseTable.vue';

import { formatPhoneNumber } from '@/libraries/PhoneNumber';

// Import external libraries
import { mapState } from 'vuex';
import _ from 'underscore';

export default {
    mixins: [DeactivateNumberMixin],

    components: { BaseTable },

    props:    ['nameConnector'],
    computed: {
        numbers () {
            return Object.values(this.phoneNumber || {});
        },

        columns () {
            return [
                {
                    key:       'attributes.phone-number',
                    label:     this.$t('phone-number'),
                    formatter: formatPhoneNumber
                },
                {
                    key:   'description',
                    label: this.$t('description')
                },
                {
                    key:     'actions',
                    label:   '',
                    thStyle: { width: '160px' },
                    tdClass: 'cell-actions'
                }
            ].filter(column => column.key !== 'description' || this.showDescription);
        },

        // State with activated phone number
        ...mapState('core/number', [
            'phoneNumber'
        ]),

        // Determine if we should show the description column based on telnyx phone number type (numbers without a config have no description)
        showDescription () {
            const configs = _.compact(_.map(this.phoneNumber, (phone) => phone.attributes.config));
            return configs.length > 0 && !_.some(configs, (config) => config.telnyx_id);
        }
    }
};
</script>
